import { Http } from '@/http/http';
import {
  FETCH_CURRENCIES_REQUEST, FETCH_CURRENCIES_SUCCESS, FETCH_CURRENCIES_ERROR,
} from './types';

const getAllCurrencies = async ({ commit }) => {
  try {
    commit(FETCH_CURRENCIES_REQUEST);
    const res = await Http.get('/currency/');
    commit(FETCH_CURRENCIES_SUCCESS, res);
    return Promise.resolve();
  } catch (e) {
    commit(FETCH_CURRENCIES_ERROR, e);
    return Promise.reject(e);
  }
};

export const actions = {
  [FETCH_CURRENCIES_REQUEST]: getAllCurrencies,
};
